import omit from "lodash/omit";

import { useCurrentUser } from "@/components/helpers/custom-hooks/use-current-user";
import { allowBuyCredits } from "@/components/helpers/workspace/permissions";
import { Box } from "@/components/layout/flexbox";
import { Nav } from "@/components/nav/Nav";
import { Authenticate } from "@/components/pages_logged_in/Authenticate";
import { PermissionErrorPage } from "@/components/pages_public/403";
import { Container } from "@/components/pieces/bootstrap";
import { AvailableCredits } from "@/components/pieces/coaching/available-credits/AvailableCredits";
import { SIDE_NAV_WIDTH } from "@/css/constants";
import { useWorkspaceCreditsQuery } from "@/graphql";
import { SessionsUser } from "@/types/users";

import { WorkspaceAdminHeader } from "./WorkspaceAdminHeader";
import { getWorkspaceAdminTabs } from "./WorkspaceAdminTabs";

function WorkspaceDashboardContainer() {
  const currentUser = useCurrentUser();
  const { data: workspaceCreditsData } = useWorkspaceCreditsQuery();

  const { currentWorkspaceCredits } = workspaceCreditsData || {
    currentWorkspaceCredits: "0",
  };

  const workspaceCreditUser = {
    availableCredits: currentWorkspaceCredits,
  };

  const tabs = getWorkspaceAdminTabs();

  if (!currentUser) return <PermissionErrorPage />;

  const user: SessionsUser = {
    __typename: "UserType",
    ...omit(currentUser, "__typename"),
    ...workspaceCreditUser,
  };

  return (
    <Box ml={[0, 0, SIDE_NAV_WIDTH]}>
      <WorkspaceAdminHeader initialTab={"dashboard"} tabs={tabs} />
      <Container>
        <AvailableCredits
          user={user}
          secondaryLabel={allowBuyCredits() ? "Buy Credits" : ""}
          secondaryLink="/buy"
          title="AVAILABLE TO DISBURSE"
          className="mt-4"
        />
      </Container>
    </Box>
  );
}

export function WorkspaceDashboard() {
  return (
    <Authenticate
      requireWorkspaceAgent={true}
      maxWidth="100%"
      layout="dashboard"
    >
      <Nav />
      <WorkspaceDashboardContainer />
    </Authenticate>
  );
}
